import { Button, Dialog, Box, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import NewIntegrationComponent from '../integration/newIntegration.component';
import { useTranslation } from 'react-i18next';


const IntegrationDialog = ({ handleSkip, successCallback, onBoardingInfo }) => {
    const { t: translate } = useTranslation();
  const [openIntegrationDialog, setOpenIntegrationDialog] = useState(false);

  useEffect(() => {
    if (onBoardingInfo?.brand_done || onBoardingInfo?.brand_skipped) {
      setOpenIntegrationDialog(true);
    }
  }, [onBoardingInfo]);

  const handleSubmitForm = () => {
    successCallback({}, "", 'integration');
    setOpenIntegrationDialog(false);
  };

  return (
  
    <Dialog
      open={openIntegrationDialog && !onBoardingInfo?.integration_done && !onBoardingInfo?.integration_skipped}
      onClose={() => setOpenIntegrationDialog(false)}
      maxWidth="lg"
      fullWidth
      
    >
      {/* Top-right Skip Button */}
      <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
        <Button variant="contained" color="primary" onClick={handleSkip}>
          {translate('organization_dialog.skip_button')}
        </Button>
      </Box>
      <DialogTitle>{translate('navbar.menu.integration')}</DialogTitle>
      <DialogContent>
        <NewIntegrationComponent handleConnect={handleSubmitForm} />
      </DialogContent>
      {/* Remove DialogActions since Skip Button is moved */}
    </Dialog>
  );
};

export default IntegrationDialog;